import { Component, OnInit, ViewChild } from '@angular/core';
import { NgbModalConfig, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { faCalendar , faFilePdf, faEye, faTrash } from '@fortawesome/free-solid-svg-icons';
import { DomSanitizer } from '@angular/platform-browser';


import { Filter } from '../../reports/filter';

import { OrdersService } from '../../../services/orders.service';
import { Order } from '../../reports/order';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';

@Component({
  selector: 'app-search-orders',
  templateUrl: './search-orders.component.html',
  styleUrls: ['./search-orders.component.css']
})
export class SearchOrdersComponent implements OnInit {

  filter: Filter = new Filter();
  wards: any;

  // ICONOS //
  faCalendar = faCalendar;
  faPdf = faFilePdf;
  faEye = faEye;
  faTrash = faTrash;

  private _orders: any[] = [];
  private _newData: boolean;

  displayedColumns: string[] = ['date', 'number', 'patient', 'service', 'action'];
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: false }) sort: MatSort;
  dataSource = new MatTableDataSource([]);

  page = 1;
  pageSize = 10;
  collectionSize = 0;
  results;
  pdf;

  status = [
    {value: 'ALL', text: 'Todos'},
    {value: 'SAVED', text: 'Guardadas'},
    {value: 'ENTERED', text: 'Ingresadas'},
    {value: 'PROCESSING', text: 'En Curso'},
    {value: 'PARTIALRESULTS', text: 'Con resultados parciales'},
    {value: 'COMPLETED', text: 'Concluidas'}
  ];

  constructor(private service: OrdersService, config: NgbModalConfig, private modalService: NgbModal, private sanitizer: DomSanitizer) {
    service.getWards().subscribe((resp) => {
      this.wards = resp;
    });
   }

  ngOnInit(): void {
  }

  public get orders(): Order[] {
    /*this.collectionSize = this._orders.length;

    return this._orders.map((order, i) => ({index: i , ...order}))
    .slice((this.page - 1) * this.pageSize, (this.page - 1) * this.pageSize + this.pageSize);*/
    return this._orders.map((order, i) => ({index: i , ...order}));

  }
  public set orders(value: Order[]) {
    this._orders = value;
  }

  public get newData(): boolean {
    return this._newData;
  }
  public set newData(value: boolean) {
    this._newData = value;
  }

  clean(): void {
    this.filter = new Filter();
    this._newData = false;
  }

  search(): void {
   this.service.searchOrders(this.filter).subscribe((resp) => {
     this._orders = resp;
     this.dataSource = new MatTableDataSource<Order>(this.orders);
     this.dataSource.paginator = this.paginator;
     this.dataSource.sort = this.sort;
     this._newData = true;
   });
  }

  viewReport(order, content) {
    const obj = [{id: order.orderId,
      lastReportId: order.lastReportId,
      orderDate: order.orderDate,
      source: order.source}];
    this.service.getReports(obj).subscribe( (resp) => {
      // const fileURL = URL.createObjectURL(resp);
      // window.open(fileURL, '_blank');
      this.pdf = this.sanitizer.bypassSecurityTrustResourceUrl(URL.createObjectURL(resp));
      this.open(content);
    });
  }

  viewReports(content) {
    const orders = this._orders.filter(order => (order.selected )).map(order => {
      const obj = {id: order.orderId,
                 lastReportId: order.lastReportId,
                 orderDate: order.orderDate,
                 source: order.source};

      return obj;
    });

    this.service.getReports(orders).subscribe( (resp) => {
      const fileURL = URL.createObjectURL(resp);
      // window.open(fileURL, '_blank');
      this.pdf = this.sanitizer.bypassSecurityTrustResourceUrl(fileURL);
      this.open(content);
    });
  }

  viewResults(order: Order, content) {
    this.service.getResults(order).subscribe( (resp) => {
      // const fileURL = URL.createObjectURL(resp);
      // window.open(fileURL, '_blank');
      this.results = this.processResults(resp);
      this.open(content);
    });
  }

  processResults(results) {
    let rootId = '';
    for ( let i = 0; i < results.length; ++i) {
      if (results[i].testId != results[i].testRootId && results[i].testRootId != rootId) {
        rootId = results[i].testRootId;
        results.splice(i, 0 , {testDescription: results[i].testRootDescription, isBold: true});
      } else if (results[i].testId == results[i].testRootId) {
        results[i].isBold = true;
      }
    }
    return results;
  }

  open(content) {
    this.modalService.open(content, { size: 'lg', backdrop: 'static' });
  }

  deleteOrder(order: Order) {
    this.service.deleteOrder(order).subscribe( (resp) => {
      // const fileURL = URL.createObjectURL(resp);
      // window.open(fileURL, '_blank');
    });
  }

  selectOrder(order: Order, index: number) {
    this.dataSource.data[index].selected = !this.dataSource.data[index].selected;
  }

}
